module.exports = __webpack_public_path__ + "static/helpericon-e2b76f2d8a89e1d78a5a0eecb74eae73.png";